var styles = {"box":"SecurityPanel_box_xlnm9_5","row":"SecurityPanel_row_xlnm9_26","list":"SecurityPanel_list_xlnm9_31"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
